import api from "./axiosInstance";

const paymentApi = {
  getAllPayments: (params = {}) => {
    return api.get("payments", { params });
  },

  getPaymentById: (id) => {
    return api.get(`payments/${id}`);
  },

  getPaymentsByInvoiceId: (invoiceId) => {
    return api.get(`payments/invoice/${invoiceId}`);
  },

  getInvoicePaymentSummary: (invoiceId) => {
    return api.get(`payments/invoice/${invoiceId}/summary`);
  },

  getNextPaymentNumber: () => {
    return api.get("payments/next-number");
  },

  createPayment: (data) => {
    return api.post("payments", data);
  },

  updatePayment: (id, data) => {
    return api.put(`payments/${id}`, data);
  },

  deletePayment: (id) => {
    return api.delete(`payments/${id}`);
  },
};

export default paymentApi;
